export default {
  fields: {
    address: 'Address',
    addressLine1: 'Address line 1',
    addressLine2: 'Address line 2',
    addressLine3: 'Address line 3',
    city: 'City',
    country: 'Country',
    county: 'County',
    description: 'Description',
    emailAddress: 'Email address',
    home: 'Home',
    mobile: 'Mobile',
    name: 'Name',
    postCode: 'Post code',
    registrationNumber: 'Registration number',
    telephoneNumber: 'Telephone number',
    title: 'Title',
    titles: {
      dr: 'Dr',
      lady: 'Lady',
      lord: 'Lord',
      mr: 'Mr',
      miss: 'Miss',
      mrs: 'Mrs',
      ms: 'Ms',
      mx: 'Mx',
      prof: 'Prof',
      sir: 'Sir',
    },
    town: 'Town',
    work: 'Work',
  },
}
